import '../../../packages/neb-lit-components/src/components/controls/neb-switch';

import './neb-icon';
import '../../../packages/neb-lit-components/src/components/neb-button';

import { html, css } from 'lit';

import { CSS_SPACING } from '../../../packages/neb-styles/neb-variables';

import { NebCardSwitch } from './neb-card-switch';

const ELEMENTS = {
  container: {
    id: 'container',
  },
  icon: {
    id: 'icon',
  },
  generateCredentialsSlot: {
    id: 'generate-credentials-slot',
  },
  labelAllUsers: {
    id: 'label-all-users',
  },
  labelDescription: {
    id: 'label-description',
  },
  labelTitle: {
    id: 'label-title',
  },
  switch: {
    id: 'switch',
  },
};

class NebCardSwitchExpanded extends NebCardSwitch {
  static get styles() {
    return [
      super.styles,
      css`
        .expanded-content {
          grid-column: 1 / -1;
          margin-top: ${CSS_SPACING};
        }
      `,
    ];
  }

  __renderExpanded() {
    return html`
      <div class="expanded-content">
        <slot name="expanded-content"></slot>
      </div>
    `;
  }

  render() {
    return html`
      <div id="${ELEMENTS.container.id}" class="container">
        <div class="content">
          <neb-icon
            id="${ELEMENTS.icon.id}"
            class="icon"
            .icon="${this.icon}"
          ></neb-icon>

          <div id="${ELEMENTS.labelTitle.id}" class="label label-title">
            ${this.title}
          </div>

          <div
            id="${ELEMENTS.labelDescription.id}"
            class="label label-description"
          >
            ${this.description}
          </div>
        </div>

        ${this.__renderSwitch()}
        <slot
          id="${ELEMENTS.generateCredentialsSlot.id}"
          name="generateCredentials"
        ></slot>
        ${this.active ? this.__renderExpanded() : ''}
      </div>
    `;
  }
}

customElements.define('neb-card-switch-expanded', NebCardSwitchExpanded);
